var _path, _linearGradient, _path2, _linearGradient2, _path3, _path4, _linearGradient3, _path5, _path6, _path7, _linearGradient4, _path8, _linearGradient5, _path9, _linearGradient6, _path10, _path11, _path12, _linearGradient7, _path13, _linearGradient8, _path14, _path15, _linearGradient9, _path16, _path17, _linearGradient10, _path18, _linearGradient11, _path19, _path20, _linearGradient12, _path21, _linearGradient13, _path22, _linearGradient14, _path23, _path24, _path25, _path26, _path27, _path28, _linearGradient15, _path29, _path30, _path31, _g, _g2, _linearGradient16, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.762 77.907h-1.74v-9.963c0-.787.051-1.745.144-2.875h-.039c-.164.661-.313 1.14-.444 1.436l-5.061 11.402h-.848l-5.071-11.319c-.142-.316-.292-.825-.443-1.519h-.038c.054.594.084 1.558.084 2.895v9.943h-1.679V63.07h2.296l4.552 10.347c.343.779.565 1.372.673 1.776h.071c.298-.811.534-1.42.711-1.82l4.651-10.303h2.179v14.837h.002zM36.118 77.907h-1.692V67.312h1.692v10.595zm.292-14.394c0 .313-.11.573-.328.787a1.074 1.074 0 01-.788.322c-.303 0-.566-.104-.782-.311-.216-.208-.322-.473-.322-.799 0-.306.106-.567.322-.779.216-.212.479-.314.782-.314.31 0 .575.103.788.314.218.213.328.474.328.78M46.691 77.417c-.812.499-1.781.746-2.902.746-1.52 0-2.742-.504-3.676-1.511-.908-.978-1.364-2.24-1.364-3.786 0-1.736.496-3.141 1.497-4.209.996-1.069 2.334-1.603 4.018-1.603.92 0 1.737.18 2.452.538v1.741c-.791-.555-1.627-.831-2.525-.831-1.079 0-1.957.377-2.637 1.128-.709.77-1.068 1.798-1.068 3.082 0 1.232.328 2.209.979 2.929.653.717 1.523 1.076 2.621 1.076.926 0 1.794-.305 2.606-.911v1.611h-.001zM54.786 69.031c-.299-.23-.729-.341-1.296-.341-.689 0-1.269.308-1.737.93-.532.694-.796 1.656-.796 2.886v5.401H49.26V67.311h1.697v2.185h.041c.249-.773.634-1.368 1.148-1.79a2.535 2.535 0 011.623-.58c.452 0 .787.049 1.016.145v1.759l.001.001zM64.237 72.628c0-1.356-.306-2.393-.918-3.103-.594-.683-1.425-1.024-2.495-1.024-1.054 0-1.9.345-2.533 1.036-.668.739-1.002 1.781-1.002 3.134 0 1.268.317 2.263.96 2.973.638.714 1.497 1.072 2.575 1.072 1.115 0 1.969-.364 2.554-1.085.573-.708.859-1.707.859-3.003m1.739-.059c0 1.688-.477 3.045-1.427 4.061-.954 1.021-2.237 1.531-3.852 1.531-1.59 0-2.856-.51-3.784-1.531-.91-.983-1.366-2.283-1.366-3.898 0-1.844.516-3.264 1.552-4.273.958-.936 2.24-1.407 3.846-1.407 1.58 0 2.814.493 3.704 1.469.882.98 1.327 2.33 1.327 4.048M74.387 75.073c0 .868-.323 1.585-.973 2.159-.709.62-1.683.93-2.908.93-1.002 0-1.881-.21-2.628-.638V75.7c.83.675 1.748 1.015 2.754 1.015 1.343 0 2.016-.495 2.016-1.48a1.31 1.31 0 00-.445-1.023c-.298-.271-.878-.594-1.739-.974-.887-.388-1.52-.787-1.893-1.2-.448-.491-.673-1.129-.673-1.915 0-.879.352-1.611 1.046-2.194.697-.585 1.592-.877 2.691-.877.842 0 1.596.164 2.266.497v1.707c-.699-.504-1.498-.755-2.405-.755-.562 0-1.013.14-1.349.412a1.32 1.32 0 00-.51 1.068c0 .469.142.834.425 1.096.252.241.786.536 1.591.879.904.379 1.558.772 1.956 1.174.517.508.778 1.156.778 1.943M84.753 72.628c0-1.356-.307-2.393-.92-3.103-.594-.683-1.426-1.024-2.494-1.024-1.055 0-1.9.345-2.536 1.036-.667.739-1 1.781-1 3.134 0 1.268.319 2.263.954 2.973.646.714 1.506 1.072 2.582 1.072 1.117 0 1.968-.364 2.554-1.085.572-.708.86-1.707.86-3.003m1.742-.059c0 1.688-.481 3.045-1.433 4.061-.95 1.021-2.233 1.531-3.848 1.531-1.592 0-2.857-.51-3.786-1.531-.909-.983-1.366-2.283-1.366-3.898 0-1.844.521-3.264 1.551-4.273.958-.936 2.241-1.407 3.849-1.407 1.581 0 2.813.493 3.7 1.469.883.98 1.333 2.33 1.333 4.048M93.968 63.711a2.278 2.278 0 00-1.126-.278c-1.188 0-1.777.747-1.777 2.245v1.633h2.483v1.438h-2.483v9.158h-1.698v-9.158h-1.802v-1.438h1.802v-1.717c0-1.166.357-2.081 1.084-2.74.622-.573 1.383-.857 2.289-.857.524 0 .932.063 1.228.184v1.53zM100.662 77.801c-.4.229-.934.343-1.593.343-1.85 0-2.774-1.042-2.774-3.128V68.75h-1.818v-1.439h1.818v-2.585c.542-.171 1.105-.357 1.7-.55v3.135h2.667v1.439h-2.667v5.979c0 .71.116 1.218.359 1.513.245.305.646.454 1.211.454.423 0 .788-.113 1.097-.342v1.447zM8.978 119.262c0 .831-.295 1.548-.895 2.155a2.939 2.939 0 01-2.17.909 2.823 2.823 0 01-2.116-.909 3.009 3.009 0 01-.868-2.155c0-.854.289-1.575.868-2.171a2.832 2.832 0 012.116-.896c.85 0 1.574.301 2.17.907.6.607.895 1.327.895 2.16M46.953 121.702h-5.532L21.342 90.694a14.226 14.226 0 01-1.217-2.442h-.165c.144.831.216 2.613.216 5.343v28.107h-4.559V82.799h5.918l19.478 30.52c.775 1.211 1.306 2.079 1.575 2.601h.108c-.18-1.119-.274-3.027-.274-5.72V82.8h4.532v38.902h-.001zM76.186 121.702H55.567V82.799h19.724v4.123H60.123v12.941h14.054v4.124H60.123v13.591h16.063v4.124zM107.46 86.922H96.254v34.781h-4.558V86.922H80.468v-4.125h26.992v4.125z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-a",
    gradientUnits: "userSpaceOnUse",
    x1: 62.394,
    y1: 415.348,
    x2: 62.782,
    y2: 415.348,
    gradientTransform: "matrix(0 149.735 149.735 0 -62135.543 -9336.014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0994DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66CEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#127BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#127BCA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-a)",
    d: "M45.407 15.604c4.399 13.452 6.064 37.449 18.928 37.449.979 0 1.969-.095 2.962-.285-11.693-2.727-13.079-26.462-20.214-38.754a59.736 59.736 0 00-1.676 1.59"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-b",
    gradientUnits: "userSpaceOnUse",
    x1: 62.447,
    y1: 415.34,
    x2: 62.836,
    y2: 415.34,
    gradientTransform: "matrix(0 153.551 153.551 0 -63717.234 -9583.969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#00ADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADEF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-b)",
    d: "M47.083 14.014c7.135 12.292 8.521 36.027 20.214 38.754a18.54 18.54 0 002.762-.746c-10.496-5.143-13.397-28.192-21.5-39.289-.491.41-.984.837-1.476 1.281"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14559A",
    d: "M57.364 6.704c-.977 0-1.969.096-2.964.285-2.603.491-5.247 1.611-7.913 3.308a19.648 19.648 0 012.073 2.438c2.711-2.249 5.404-3.911 8.087-4.911a18.1 18.1 0 013.017-.838 9.23 9.23 0 00-2.3-.282"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-c",
    gradientUnits: "userSpaceOnUse",
    x1: 66.554,
    y1: 416.985,
    x2: 66.942,
    y2: 416.985,
    gradientTransform: "matrix(0 -122.178 -122.178 0 51016.945 8183.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1C63B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#33BDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BDF2",
    stopOpacity: 0.42
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-c)",
    d: "M78.251 47.282a47.07 47.07 0 003.228-2.829c-4.47-13.389-6.07-37.729-19.023-37.729-.926 0-1.861.086-2.792.259 11.798 2.934 13.309 28.605 18.587 40.299"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3092C4",
    d: "M59.664 6.984a9.28 9.28 0 00-2.301-.281l5.094.019c-.927 0-1.861.086-2.793.262"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M78.026 50.126a19.144 19.144 0 01-1.46-1.579c-2.179 1.543-4.351 2.713-6.507 3.475.767.375 1.572.653 2.426.826a10.22 10.22 0 002.067.205c2.421 0 4.334-.286 5.963-1.068-.897-.485-1.72-1.112-2.489-1.859"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-d",
    gradientUnits: "userSpaceOnUse",
    x1: 62.568,
    y1: 415.281,
    x2: 62.957,
    y2: 415.281,
    gradientTransform: "matrix(0 159.425 159.425 0 -66138.813 -9976.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#166AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#36AEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#0798DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0798DD"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-d)",
    d: "M56.646 7.825c10.569 5.528 11.487 30.56 19.92 40.723.565-.398 1.125-.82 1.684-1.265-5.279-11.695-6.788-37.368-18.585-40.3a18.21 18.21 0 00-3.019.842"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-e",
    gradientUnits: "userSpaceOnUse",
    x1: 62.648,
    y1: 415.368,
    x2: 63.037,
    y2: 415.368,
    gradientTransform: "matrix(0 169.528 169.528 0 -70353.656 -10621.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#124379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1487CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#165197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165197"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-e)",
    d: "M48.559 12.734c8.103 11.097 11.004 34.146 21.5 39.289 2.158-.762 4.328-1.932 6.507-3.475-8.433-10.163-9.352-35.195-19.92-40.723-2.683.998-5.376 2.66-8.087 4.909"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-f",
    gradientUnits: "userSpaceOnUse",
    x1: 1006.493,
    y1: -1588.315,
    x2: 1008.801,
    y2: -1588.315,
    gradientTransform: "matrix(4.038 0 0 -4.038 -4028.633 -6394.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33BDF2",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DACD8"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-f)",
    d: "M40.222 15.28c-1.271 2.872-2.568 6.646-4.136 11.574 3.118-4.395 6.228-8.181 9.32-11.25a33.912 33.912 0 00-1.376-3.592 46.51 46.51 0 00-3.808 3.268"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B74B1",
    d: "M45.157 11.184c-.373.267-.749.54-1.125.828a33.784 33.784 0 011.375 3.592 65.928 65.928 0 011.677-1.59 22.658 22.658 0 00-1.927-2.83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#125A9E",
    d: "M46.486 10.296c-.443.281-.884.577-1.331.887a22.376 22.376 0 011.928 2.833c.493-.446.985-.875 1.476-1.282a19.563 19.563 0 00-2.073-2.438"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-g",
    gradientUnits: "userSpaceOnUse",
    x1: 66.607,
    y1: 417.481,
    x2: 66.996,
    y2: 417.481,
    gradientTransform: "matrix(0 -119.018 -119.018 0 49793.875 7977.832)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#136AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59CAF5",
    stopOpacity: 0.549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CAF5",
    stopOpacity: 0.235
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-g)",
    d: "M118.572 5.68c-5.977 23.05-18.461 41.565-28.927 46.232h-.021l-.565.241-.068.027-.161.062-.072.03-.261.092-.108.038-.13.043-.126.044-.112.037-.223.068-.095.025-.151.041-.102.028-.164.042-.201.044c.473.175.966.263 1.497.263 9.924 0 19.932-17.786 36.489-47.363h-6.501l.002.006z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-h",
    gradientUnits: "userSpaceOnUse",
    x1: 998.304,
    y1: -1591.054,
    x2: 1006.863,
    y2: -1591.054,
    gradientTransform: "matrix(4.038 0 0 -4.038 -4028.633 -6394.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-h)",
    d: "M33.931 7.64l.018-.017.023-.015h.013l.161-.062.032-.016.041-.018.173-.062h.009l.381-.133.056-.015.164-.049.075-.024.164-.049.063-.016.545-.142.075-.017.159-.031.079-.024.16-.03h.037l.332-.062h.066l.153-.026.086-.016.146-.022.082-.015.357-.032a11.398 11.398 0 00-1.057-.054c-11.177 0-26.576 20.738-33.513 47.594h1.337a388.226 388.226 0 006.037-11.22c4.859-19.022 14.754-31.996 23.544-35.433"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D82CA",
    d: "M40.222 15.28a46.677 46.677 0 013.808-3.268 17.903 17.903 0 00-.907-1.753c-1.022 1.241-1.956 2.877-2.901 5.021M41.141 7.797c.73.611 1.383 1.454 1.982 2.462a9.1 9.1 0 01.578-.646A11.294 11.294 0 0041 7.724l.119.057.022.016"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-i",
    gradientUnits: "userSpaceOnUse",
    x1: 66.556,
    y1: 416.357,
    x2: 66.944,
    y2: 416.357,
    gradientTransform: "matrix(0 -121.865 -121.865 0 50761.691 8162.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#318ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A7E4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-i)",
    d: "M10.388 43.072c10.191-19.64 15.02-32.069 23.544-35.433-8.789 3.439-18.686 16.412-23.544 35.433"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#127BCA",
    d: "M43.7 9.614c-.199.203-.387.415-.578.646.32.536.618 1.119.909 1.753.376-.289.752-.561 1.125-.829a15.339 15.339 0 00-1.456-1.57"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-j",
    gradientUnits: "userSpaceOnUse",
    x1: 66.632,
    y1: 416.408,
    x2: 67.021,
    y2: 416.408,
    gradientTransform: "matrix(0 -118.46 -118.46 0 49352.684 7945.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A1E6",
    stopOpacity: 0.549
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-j)",
    d: "M15.015 54.203l-.185.022h-.035l-.157.016h-.026l-.374.025h-.039c10.314-.289 15.03-5.453 17.37-12.944 1.777-5.678 3.238-10.462 4.518-14.476-4.32 6.081-8.661 13.33-13.024 21.451-2.104 3.914-5.304 5.549-8.048 5.898"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-k",
    gradientUnits: "userSpaceOnUse",
    x1: 67.153,
    y1: 416.523,
    x2: 67.542,
    y2: 416.523,
    gradientTransform: "matrix(0 -100.1 -100.1 0 41721.719 6776.301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1959A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#7EC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EC5EA"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-k)",
    d: "M15.015 54.199c2.744-.35 5.944-1.983 8.048-5.899 4.363-8.118 8.706-15.369 13.022-21.451 1.571-4.929 2.866-8.701 4.138-11.573-8.604 8.189-17.24 21.806-25.208 38.919"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A1E6",
    d: "M10.388 43.072a389.833 389.833 0 01-6.039 11.22h3.889a94.927 94.927 0 012.149-11.218"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-l",
    gradientUnits: "userSpaceOnUse",
    x1: 66.874,
    y1: 415.998,
    x2: 67.262,
    y2: 415.998,
    gradientTransform: "scale(-110.211 110.211) rotate(-80 -214.299 248.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#165096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D82CA"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-l)",
    d: "M37.225 6.791l-.083.016-.146.021-.085.015-.153.027-.066.016-.332.058h-.037l-.162.032-.081.021-.157.031-.074.018-.546.142-.063.019-.165.049-.075.019-.163.048-.06.016-.379.133-.172.06-.072.03-.16.06-.053.026c-8.523 3.364-13.352 15.793-23.543 35.432a94.598 94.598 0 00-2.15 11.218h.546l3.739-.016h1.714l.374-.025h.024l.157-.016h.038l.185-.022c7.967-17.112 16.604-30.729 25.208-38.918.945-2.144 1.878-3.781 2.898-5.02-.597-1.008-1.25-1.853-1.98-2.465L41.13 7.8l-.122-.059-.12-.061-.117-.057-.138-.058-.108-.047-.226-.094-.096-.037-.168-.067-.091-.03-.234-.08h-.019l-.271-.077-.061-.019-.228-.064-.053-.015a6.956 6.956 0 00-.567-.124l-.059-.016-.246-.04-.048-.015-.291-.038h-.051l-.224-.025-.357.033"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-m",
    gradientUnits: "userSpaceOnUse",
    x1: 68.837,
    y1: 418.884,
    x2: 69.226,
    y2: 418.884,
    gradientTransform: "matrix(0 -56.721 -56.721 0 23857.477 3932.282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05A1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#0495D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0495D6"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-m)",
    d: "M95.226 18.441c-1.961 6.281-3.549 11.463-4.931 15.727 5.381-7.404 10.68-16.718 15.728-27.467-5.889 1.849-9.029 6.081-10.797 11.74"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-n",
    gradientUnits: "userSpaceOnUse",
    x1: 62.48,
    y1: 414.361,
    x2: 62.868,
    y2: 414.361,
    gradientTransform: "scale(-132.813 132.813) rotate(80 277.722 169.477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38A7E4",
    stopOpacity: 0.329
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#0E88D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E88D3"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-n)",
    d: "M90.465 51.52c-.274.14-.55.272-.82.393 10.466-4.668 22.951-23.183 28.927-46.233h-1.211c-13.733 24.53-18.149 40.952-26.896 45.84"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#079AE1",
    d: "M83.631 49.459c2.277-2.779 4.132-7.504 6.665-15.292-2.921 4.012-5.861 7.462-8.804 10.274l-.015.025c.642 1.923 1.346 3.622 2.149 4.992"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1969BC",
    d: "M83.631 49.459c-.775.946-1.596 1.666-2.509 2.2-.2.117-.402.227-.608.326.964.52 2.016.868 3.193 1.007l.522.046h.031l.251.016h.852l.096-.016.188-.016h.091l.205-.022h.015l.063-.015.218-.034h.064l.245-.041h.039l.489-.104c-1.351-.493-2.481-1.66-3.455-3.32"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E5CB3",
    d: "M64.335 53.053c.979 0 1.968-.096 2.961-.287.919-.167 1.84-.422 2.762-.744a10.093 10.093 0 004.494 1.031H64.335zM74.552 53.053c2.419 0 4.334-.287 5.962-1.068a8.8 8.8 0 003.193 1.007l.522.045h.031l.251.016h.301-10.26z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D60B5",
    d: "M84.812 53.053h.559l.096-.016.19-.016h.093l.203-.022h.017l.062-.015.218-.033.066-.015.246-.04h.039l.489-.104a4.28 4.28 0 001.498.263l-3.773.016-.003-.018z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#175FAB",
    d: "M81.482 44.467v-.016a46.856 46.856 0 01-3.228 2.83c-.561.445-1.12.867-1.686 1.265a19.14 19.14 0 001.461 1.579c.77.746 1.591 1.374 2.488 1.859.205-.1.408-.21.607-.326.915-.534 1.734-1.254 2.51-2.2-.803-1.37-1.507-3.069-2.148-4.992"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-o",
    gradientUnits: "userSpaceOnUse",
    x1: 62.071,
    y1: 414.653,
    x2: 62.459,
    y2: 414.653,
    gradientTransform: "matrix(0 123.742 123.742 0 -51209.754 -7675.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#168CD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C87CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154B8D"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-o)",
    d: "M113.525 5.68h-6.096l-.966.047-.45.962c-5.046 10.749-10.346 20.063-15.727 27.468-2.53 7.786-4.387 12.511-6.664 15.291.973 1.661 2.106 2.829 3.452 3.324l.106-.023h.022l.074-.017.169-.042.1-.029.151-.04.094-.026.224-.068.112-.037.126-.046.129-.041.105-.04.263-.092.073-.027.161-.063.069-.025.565-.241h.019c.271-.12.546-.253.819-.393 8.75-4.888 13.166-21.31 26.898-45.84h-3.835l.007-.002z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#7DCBEC",
    d: "M37.583 6.758l.063.016.159.017h.054l.29.037.05.016.245.041.061.015.566.125.051.016.227.064.063.019.269.077.02.016.236.081.09.029.169.069.096.034.224.094.11.047.135.059.12.056.119.062a11.284 11.284 0 012.702 1.89c.305-.322.625-.61.958-.87-1.815-1.288-3.874-2.022-6.246-2.022-.275 0-.549.016-.829.037"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EC5ED",
    d: "M43.7 9.614c.508.473.995 1.001 1.456 1.57.445-.31.887-.608 1.331-.887a13.917 13.917 0 00-1.831-1.553 8.418 8.418 0 00-.956.87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.048 0 0 -5.048 -9064.26 2270.61)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-p",
    gradientUnits: "userSpaceOnUse",
    x1: 1807.241,
    y1: 366.152,
    x2: 1807.63,
    y2: 366.152,
    gradientTransform: "scale(30.857 -30.857) rotate(22.527 1888.666 -4214.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97D6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#55C1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C1EA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-p)",
    d: "M1803.007 448.452l.164.007c.47 0 .878-.145 1.237-.4.38.299.838.404 1.476.404h-3.086l.209-.011"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.048 0 0 -5.048 -9064.26 2270.61)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-q",
    gradientUnits: "userSpaceOnUse",
    x1: 1808.472,
    y1: 365.322,
    x2: 1808.861,
    y2: 365.322,
    gradientTransform: "scale(24.717 -24.717) rotate(-24.385 53.536 4189.483)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ACCEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB7ED"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-q)",
    d: "M1805.884 448.463c-.637 0-1.096-.105-1.476-.404.126-.089.247-.192.362-.307.528.336 1.052.558 1.568.656.197.037.393.056.587.056h-1.041v-.001z"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-net-original-wordmark-r",
    gradientUnits: "userSpaceOnUse",
    x1: 61.991,
    y1: 414.706,
    x2: 62.38,
    y2: 414.706,
    gradientTransform: "matrix(0 121.032 121.032 0 -50098.906 -7494.747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1DA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ABE7",
    stopOpacity: 0
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dot-net-original-wordmark-r)",
    d: "M90.295 34.172c1.384-4.267 2.968-9.447 4.933-15.73 1.771-5.661 4.905-9.894 10.792-11.741l.454-.962c-9.597.575-14.082 5.457-16.339 12.687-3.947 12.622-6.339 20.803-8.641 26.017 2.94-2.812 5.88-6.263 8.801-10.271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotnet);
export default __webpack_public_path__ + "static/media/dotnet.4df9c0648f3374dfe53ee205d3ab76b4.svg";
export { ForwardRef as ReactComponent };